import moment from 'moment';

export default {
  computed: {
    showUnreadNotificationOnly() {
      return this.isChecked;
    },

    filteredNotifications() {
      return this.notifications?.filter(n => {
        return !this.showUnreadNotificationOnly || (this.showUnreadNotificationOnly && !n.read);
      }) || [];
    },

    newNotifications() {
      const today = moment().startOf('day');
      const tomorrow = moment().add(1, 'days').startOf('day');

      return this.filteredNotifications?.filter(notification => {
        const date = moment(notification.created_at);
        return date.isSameOrAfter(today) && date.isBefore(tomorrow);
      });
    },

    lastWeekNotifications() {
      const today = moment().startOf('day');
      const sevenDaysAgo = moment().subtract(7, 'days').startOf('day');

      return this.filteredNotifications?.filter(notification => {
        const date = moment(notification.created_at);
        return date.isSameOrAfter(sevenDaysAgo) && date.isBefore(today);
      });
    },

    lastMonthNotifications() {
      const sevenDaysAgo = moment().subtract(7, 'days').startOf('day');
      const oneMonthAgo = moment().subtract(1, 'months').startOf('day');

      return this.filteredNotifications?.filter(notification => {
        const date = moment(notification.created_at);
        return date.isSameOrAfter(oneMonthAgo) && date.isBefore(sevenDaysAgo);
      });
    },

    olderNotifications() {
      const oneMonthAgo = moment().subtract(1, 'months').startOf('day');

      return this.filteredNotifications?.filter(notification => {
        const date = moment(notification.created_at);
        return date.isBefore(oneMonthAgo);
      });
    }
  },
};
